import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {NotificationModel} from './notification.model';
import {UserModel} from '../../pages/user.model';

@Injectable()
export class NavigationService {

  private pollingDuration = 600000;

  private navigationDataObservable: Observable<UserModel>;

  constructor(private http: HttpClient) {}

  getNavigationData() {
    return Observable.timer(0, this.pollingDuration)
      .switchMap(() => this.http.get<NotificationModel>('//api.feelwaypawnshop.com/api/dashboard/work/notify'));


  }

}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/shared/header-navigation/navigation.service.ts